<div class="stepper" *transloco="let t">
  <div class="mt-2">
    <ol class="stepper-progress is-titled">
      <li [ngClass]="{'is-complete': step.completed, 'is-active': step.active}" (click)="doSelectStep(step,i)" *ngFor="let step of steps; let i = index"><span>{{step.translationKey ? t(step.translationKey) : step.text}}</span></li>
    </ol>
  </div>
</div>
